var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04812 15.4872C2.16181 15.7638 3.14043 17.884 5.22189 20.0205C7.35847 22.1031 9.47969 23.0805 9.75512 23.1942C10.9974 23.7462 14.2403 25.1656 17.01 23.9748C18.6449 23.2728 19.5239 21.8781 19.8064 21.3917C20.1298 20.828 19.9623 20.1705 19.3985 19.847C17.9581 19.0125 16.5247 18.1816 15.0867 17.3565C14.8019 17.1971 14.496 17.1549 14.2194 17.2369C13.8983 17.3272 13.7096 17.5604 13.5502 17.7655C12.7017 18.8484 12.6325 19.4391 12.3407 19.6735C12.0641 19.8986 11.4945 19.922 10.2709 19.2751C8.44024 18.3058 6.93425 16.7998 5.96484 14.9689C5.3167 13.7454 5.34133 13.1746 5.56636 12.8992C5.80076 12.6085 6.39146 12.5394 7.4744 11.6897C7.67833 11.5303 7.91509 11.3381 8.00297 11.0205C8.08384 10.7439 8.04165 10.438 7.88343 10.1532C7.05833 8.71277 6.22739 7.27941 5.3929 5.84138C5.06943 5.27764 4.41193 5.10887 3.8482 5.43351C3.35947 5.71831 1.96362 6.59731 1.26508 8.22992C0.076669 11.0041 1.49844 14.2448 2.04812 15.4872Z",
    fill: "#4D5C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8085 6.95966C24.8085 3.35924 21.8867 0.4375 18.2863 0.4375C14.686 0.4375 11.7642 3.35933 11.7642 6.95966C11.7642 8.31918 12.1814 9.58497 12.8951 10.6315L11.7642 13.4818L14.6145 12.3508C15.6611 13.0646 16.928 13.4818 18.2863 13.4818C21.8867 13.4853 24.8085 10.5635 24.8085 6.95966Z",
    fill: "#4D5C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.5679e61a275aa92e4e26b4ec04bf6ee1.svg";
export { ForwardRef as ReactComponent };